import ApiService from "@/core/services/api.service";

const CACHE_TTL_MS = 60 * 1000;
const cache = new Map();

function cacheKey({ branchId, date }) {
	return `${String(branchId ?? "")}::${String(date ?? "")}`;
}

/**
 * Fetches today's (or provided date) cashier session for a branch, with a short in-memory TTL.
 * Returns the session object or null.
 */
export async function getCdcTodaySession({ branchId, date }) {
	if (!branchId) return null;
	const d = date || new Date().toISOString().split("T")[0];
	const key = cacheKey({ branchId, date: d });
	const now = Date.now();

	const hit = cache.get(key);
	if (hit && now - hit.at < CACHE_TTL_MS) {
		return hit.value;
	}

	const res = await ApiService.get("/cashier-sessions/today", {
		params: { date: d, branch_id: branchId },
	});
	const session = res?.data?.data ?? null;
	cache.set(key, { at: now, value: session });
	return session;
}

export function invalidateCdcTodaySession({ branchId, date }) {
	const d = date || new Date().toISOString().split("T")[0];
	cache.delete(cacheKey({ branchId, date: d }));
}

export function isCdcLocked(session) {
	const s = session?.status;
	return s === "pending_review" || s === "closed";
}

